import { Links, Meta, Outlet, Scripts, ScrollRestoration, isRouteErrorResponse } from "react-router";
import type { Route } from "./+types/root";
import "./styles.css";

// Every document this app serves is Persian, so `lang` and `dir` are constants
// here rather than the path-derived values apps/frontend has to compute. That is
// the main reason this is a separate app: the English site has to decide, and
// this one never does.
export const links: Route.LinksFunction = () => [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Vazirmatn:wght@400;500;700&display=swap",
  },
];

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="fa" dir="rtl">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {/* No og:locale anywhere in this app. Its only well-formed Persian value
            is fa_IR, which names a country this surface deliberately does not
            reference. hreflang carries the language, which is the part a crawler
            actually needs. Decided 20 Aug 2026, carried over here unchanged. */}
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function App() {
  return <Outlet />;
}

export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
  const is404 = isRouteErrorResponse(error) && error.status === 404;
  return (
    <main className="mx-auto max-w-2xl px-6 py-24 text-center">
      <h1 className="mb-4 text-3xl font-bold text-brand-navy">
        {is404 ? "صفحه پیدا نشد" : "خطایی رخ داد"}
      </h1>
      <p className="mb-8 text-ink-soft">
        {is404
          ? "این نشانی وجود ندارد یا جابه‌جا شده است."
          : "مشکلی پیش آمد. لطفاً دوباره تلاش کنید."}
      </p>
      <a href="/" className="text-brand-teal underline">
        بازگشت به صفحه‌ی اصلی
      </a>
    </main>
  );
}
